import React from 'react'

import { useRouter } from '@tribeplatform/react-sdk'
import {
  Dropdown,
  DropdownItemProps,
} from '@tribeplatform/react-ui-kit/Dropdown'

import type { PostActionItem } from './hooks/usePostActionItems.js'

type ActionItemProps = PostActionItem & {
  isShortcut: boolean
}
export const ActionItem = ({
  action,
  hotkey,
  icon: Icon,
  name,
  url,
  disabled,
  isShortcut,
}: ActionItemProps) => {
  const { Link } = useRouter()
  const handleClick: DropdownItemProps['onClick'] = e => {
    if (isShortcut) {
      e.preventDefault()
    }
    action?.()
  }
  const icon = React.isValidElement(Icon) ? Icon : <Icon />

  if (action) {
    return (
      <Dropdown.Item
        onClick={handleClick}
        hotkey={hotkey}
        disabled={disabled}
        leadingIcon={icon}
      >
        {name}
      </Dropdown.Item>
    )
  }

  return (
    <Dropdown.Item
      as={Link}
      href={url}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      variant="inherit"
      hotkey={hotkey}
      disabled={disabled}
      onClick={handleClick}
      leadingIcon={icon}
    >
      {name}
    </Dropdown.Item>
  )
}
